import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCreateLcrWorksheetMacro = (crId, lcrId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    (macroData) => (
      axiosInstance.post(liveCleanroom(orgId)
        .createWorksheetMacro(crId, lcrId, worksheetId),
      macroData)
    ),
    {
      onSuccess: () => {
        dispatch(
          showAlert({
            message: 'Macro created successfully',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error creating macro',
            type: 'error',
          }),
        );
      },
    },
  );
};
